import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  AddButton,
  BackButton,
  ThinDropdown,
  ThinTextField,
} from "../../common/GeneralComponent";
import { fetchData } from "../../../utils/functions";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ChevronFirstIcon, ChevronLast, Pencil } from "lucide-react";
import Loader from "../../../components/partials/Loader";

const EditProvinces = () => {
  const { id } = useParams();

  const [provinceData, setProvinceData] = useState({
    provinceName: "",
    status: "",
  });
  const [isFetching, setIsFetching] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(true);

  const fetchProvinces = async () => {
    try {
      const response = await fetchData(
        "provinces",
        "GET",
        null,
        {}, // Headers
        { province_id: id }, 
        navigate,
        "/provinces",
        dispatch
      );
      const data = response?.data;
      if (data && data.length > 0) {
        setProvinceData({
          provinceName: data[0].province || "", 
          status: data[0].status === 1 ? "Active" : "In-Active",
        });

        // Set status in Formik form state
        formik.setFieldValue(
          "status",
          data[0].status === 1 ? "Active" : "In-Active" 
        );
      }
      setLoader(false);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setLoader(false);
      toast.error("Failed to load province data.");
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchProvinces();
  }, [id]);

  const validationSchema = Yup.object({
    provinceName: Yup.string()
      .min(3, "Province name must be at least 3 characters")
      .max(50, "Province name must not exceed 50 characters")
      .matches(/^[^\d].*/, "Province name must not start with a number")
      .required("Province name is required"),
    status: Yup.string().required("Status is required"),
  });

  const formik = useFormik({
    initialValues: provinceData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {

      const data = {
        Province_Id: id,
        Province: values.provinceName,
        status: values.status === "Active" ? 1 : 0,
      };


      try {
        setIsSubmitting(true);
        const response = await fetchData(`provinces`, "PUT", data);
        toast.success(response.message || "Province updated successfully!");
        navigate("/provinces");
      } catch (error) {
        console.error(error);
        toast.error(error.message || "Failed to update province.");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  useEffect(() => {
    setTimeout(() => {}, 2000);
  }, []);

  return (
    <div className="w-full my-4 mx-auto">
    
      {loader && <Loader />}
<div className="flex  lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
    <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
               Edit Province
             </h1>
    <BackButton text="Back" to="/provinces" />
         </div>
      <div  className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4  mb-[7rem]">
      

            <div  className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
         <h1  className="lg:text-[0.875rem] text-[13px]  tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
             Edit Province
          </h1>
        
        </div>
        <form  className="p-4" onSubmit={formik.handleSubmit}>
          <div className="flex lg:flex-nowrap flex-wrap  gap-5 ">
            <ThinTextField
              id="provinceName"
              label="Province Name"
              placeholder="Province Name"
              type="text"
              value={formik.values.provinceName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.provinceName && formik.errors.provinceName}
              helperText={
                formik.touched.provinceName && formik.errors.provinceName
              }
            />

            <ThinDropdown
              label="Status"
              id="status-dropdown"
              options={[
                { value: "Active", label: "Active" },
                { value: "In-Active", label: "In-Active" },
              ]}
              value={formik.values.status}
              onChange={(e) => formik.setFieldValue("status", e.target.value)}
              onBlur={formik.handleBlur}
              error={formik.touched.status && formik.errors.status}
            />
          </div>
          <div className="p-4">
          <AddButton
            text="Submit"
            type="Submit"
            isLoading={isSubmitting}
            icon={Pencil}
          />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProvinces;